import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../ComponentCss/Admin.css";
import axios from "axios";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import apiClient from '../utlis/apiClient';
import appShive from "../image/full logo.png";

const Admin = () => {
  const [companyEmail, setCompanyEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [open, setOpen] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    setOpen(false);

    try {
      const response = await apiClient.post(
        `/api/users/login`,
        {
          companyEmail,
          password,
        }
      ); 

      console.log(response)

      if (response.data.message === "Login successful") {

        console.log(response.data)
        // Clear existing token and user details from localStorage
        localStorage.removeItem("token");
        localStorage.removeItem("company");

        // Store token and user details in localStorage
        localStorage.setItem("token", response.data.token);
        localStorage.setItem("user", JSON.stringify(response.data.company));

        const { token } = response.data;
        console.log(token)
        sessionStorage.setItem("authToken", token); 

        setSuccess("Login successful");
        setOpen(true);
        navigate("/ManageTender");
      }
    } catch (err) {
      console.log(err)
      setError(err.response?.data?.message || "Invalid email or password");
      setOpen(true);
    }
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") return;
    setOpen(false);
  };

  return (
    <div className="Adminlogin">
      <div className="container" 
          style={{ 
            background: "linear-gradient(to top, #ff5317, #ffae00)" 
           }}>
        <div className="sign_in form_container">
          <form onSubmit={handleLogin}>
            <h1>Sign In</h1>
            <br />
            <input
              className="email1"
              type="email"
              placeholder="Email"
              value={companyEmail}
              onChange={(e) => setCompanyEmail(e.target.value)}
              required
            />
            <p className="emailfield1 text">
              <i className="fa-solid fa-circle-exclamation"></i>
              Please enter a valid email-address
            </p>

            <div className="passdiv" style={{ position: "relative" }}>
                <input
                  className="pass1"
                  type={showPassword ? "text" : "password"}
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
                <i
                  className={`fa-solid ${showPassword ? "fa-eye-slash" : "fa-eye"} show-hide`}
                  onClick={() => setShowPassword(!showPassword)}
                  style={{
                    position: "absolute",
                    right: "10px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                  }}
                ></i>
              </div>




            <p className="passfield1 text">
              <i className="fa-solid fa-circle-exclamation"></i> Please enter a
              valid password
            </p>

            <button type="submit" style={{cursor: "pointer"}}>SIGN IN</button>
          </form>
        </div>
        <div className="toggle_container">
          <div className="toggle">
            <div className="toggle_panel toggle_right">
              <img
                src={appShive}
                alt="Description of the image"
                style={{ height: "140px" }}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Snackbar for error/success messages */}
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        {error ? (
          <Alert onClose={handleClose} severity="error" sx={{ width: "100%" }}>
            {error}
          </Alert>
        ) : (
          <Alert
            onClose={handleClose}
            severity="success"
            sx={{ width: "100%" }}
          >
            {success}
          </Alert>
        )}
      </Snackbar>
    </div>
  );
};

export default Admin;
